/**
 * useAuthors - Hook to fetch users who can be authors (for author dropdowns)
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface AuthorOption {
  value: string;
  label: string;
  slug: string;
}

interface AuthorsResponse {
  users: AuthorOption[];
}

async function fetchAuthors(siteId: string): Promise<AuthorOption[]> {
  const response = await api.get<AuthorsResponse>(`/api/v1/sites/${siteId}/users`);
  return response.users;
}

export function useAuthors(siteId: string | undefined) {
  return useQuery({
    queryKey: ['authors', siteId],
    queryFn: () => fetchAuthors(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
